<template> 
  <div>
    Carregando...
  </div>
</template>

<script>
export default {
  name: 'AcceptNewEmail',
  data () {
    return {
    }
  },
  metaInfo () {
    return {
      title: 'Carregando...'
    }
  },
  created () {
    this.acceptMember()
  },
  methods: {
    acceptMember () {
      this.$store
      .dispatch('authAcceptNewEmail', this.$route.params.token)
      .then(() => {
        this.$router.push('/config')
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Auth/AcceptNewEmail.vue